// Material-ui
import { makeStyles, createStyles } from '@material-ui/core';
/** Row component styles */
export var rowStyles = function (theme) { return createStyles({
    listItemIcon: {},
    listItemText: {},
    root: {
        '&:hover': {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
        padding: 0,
    },
    rootActive: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    typography: {}
}); };
/**
 * Row component classes styles
 */
export var useRowStyles = makeStyles(rowStyles);
//# sourceMappingURL=row.style.js.map